import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AyaktanHasta from '../assets/images/surveys/ayaktanhasta.png';
import YatanHasta from '../assets/images/surveys/yatanhasta.png';
import AcilServis from '../assets/images/surveys/acilservis.png';
import Recete3 from "../assets/images/recete3.jpg"
import AboutHero from '../components/common/AboutHero';

interface SurveyCard {
  id: string;
  title: string;
  subtitle: string;
  image: string;
  color: string;
  link: string;
}

const surveyCards: SurveyCard[] = [
  {
    id: '1',
    title: 'Ayaktan Hasta',
    subtitle: 'Memnuniyet Formu',
    image: AyaktanHasta,
    color: '#4CAF50',
    link: '/anket/ayaktan-hasta'
  },
  {
    id: '2',
    title: 'Yatan Hasta',
    subtitle: 'Memnuniyet Formu',
    image: YatanHasta,
    color: '#f44336',
    link: '/anket/yatan-hasta'
  },
  {
    id: '3',
    title: 'Acil Servis',
    subtitle: 'Memnuniyet Formu',
    image: AcilServis,
    color: '#4CAF50',
    link: '/anket/acil-servis'
  }
];

const HastaMemnuniyetAnketleriPage: React.FC = () => {
  return (
    <>
       <AboutHero
        image={Recete3}
        kicker="Megapark Hastanesi"
        title="Memnuniyet Anketleri"
        description=""
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />
      {/* Survey Cards Section */}
      <section className="py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="mb-3">Memnuniyet Formları</h2>
            <p className="text-muted">
              Görüş ve önerileriniz bizim için çok değerlidir. Lütfen ilgili formu doldurarak
              hizmet kalitemizi değerlendirmenize yardımcı olun.
            </p>
          </div>
          
          <Row className="g-4">
            {surveyCards.map((survey) => (
              <Col key={survey.id} xs={12} md={6} lg={4}>
                <Card className="survey-card h-100 border-0 shadow-sm">
                  <div className="survey-image-wrapper">
                    <Card.Img 
                      variant="top" 
                      src={survey.image} 
                      alt={survey.title}
                      className="survey-image"
                      style={{ height: '250px', objectFit: 'cover' }}
                    />
                  </div>
                  <Card.Body className="d-flex flex-column">
                    <div className="mb-3">
                      <p className="text-muted mb-1 small">{survey.subtitle}</p>
                      <Card.Title 
                        className="fw-bold mb-3"
                        style={{ color: survey.color }}
                      >
                        {survey.title}
                      </Card.Title>
                    </div>
                    <div className="mt-auto">
                      <Link 
                        to={survey.link}
                        className="btn btn-danger w-100 rounded-pill"
                        style={{ 
                          backgroundColor: '#2cadd2',
                          borderColor: '#dc3545'
                        }}
                      >
                        FORMU DOLDUR
                      </Link>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default HastaMemnuniyetAnketleriPage;
